/** Vista UX segura: platform_designer simula flujo comprador sin cambiar rol ni backend. */
export const PLATFORM_DESIGNER_BUYER_PREVIEW_STORAGE_KEY = "visor:platform_designer_buyer_preview";
export const PLATFORM_DESIGNER_BUYER_PREVIEW_ORG_KEY = "visor:platform_designer_buyer_preview_org";

export const PLATFORM_DESIGNER_BUYER_PREVIEW_BANNER =
  "Vista simulada — no cambia permisos reales ni activa licencias.";

export const PLATFORM_DESIGNER_BUYER_PREVIEW_NO_ORG_TITLE = "Vista de prueba como comprador";
export const PLATFORM_DESIGNER_BUYER_PREVIEW_NO_ORG_BODY =
  "Selecciona una organización o comprador real para previsualizar su experiencia completa.";

export const PLATFORM_DESIGNER_BUYER_PREVIEW_SIMULATED_NOTE =
  "Esta es una vista simulada. Para ver datos reales, selecciona una organización.";

export function readPlatformDesignerBuyerPreview() {
  try {
    return localStorage.getItem(PLATFORM_DESIGNER_BUYER_PREVIEW_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function writePlatformDesignerBuyerPreview(active) {
  try {
    if (active) {
      localStorage.setItem(PLATFORM_DESIGNER_BUYER_PREVIEW_STORAGE_KEY, "1");
    } else {
      localStorage.removeItem(PLATFORM_DESIGNER_BUYER_PREVIEW_STORAGE_KEY);
      localStorage.removeItem(PLATFORM_DESIGNER_BUYER_PREVIEW_ORG_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function readPlatformDesignerBuyerPreviewOrgId() {
  try {
    return (localStorage.getItem(PLATFORM_DESIGNER_BUYER_PREVIEW_ORG_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function writePlatformDesignerBuyerPreviewOrgId(orgId) {
  try {
    const id = String(orgId || "").trim();
    if (id) {
      localStorage.setItem(PLATFORM_DESIGNER_BUYER_PREVIEW_ORG_KEY, id);
    } else {
      localStorage.removeItem(PLATFORM_DESIGNER_BUYER_PREVIEW_ORG_KEY);
    }
  } catch {
    /* ignore */
  }
}

/** @deprecated Ya no se usa para forzar trial vencido en preview — conservado por compatibilidad de imports. */
export function applyBuyerPreviewSystemInfoOverlay(systemInfo) {
  if (!systemInfo) {
    return buildEmptyBuyerPreviewSimulationSystemInfo();
  }
  const sub = systemInfo.subscription || {};
  if (sub.mode !== "platform_designer") {
    return systemInfo;
  }
  return buildEmptyBuyerPreviewSimulationSystemInfo();
}

/** systemInfo mínimo para simulación sin organización (sin CTAs legacy). */
export function buildEmptyBuyerPreviewSimulationSystemInfo() {
  return {
    subscription: { mode: "preview", ok: true, reason: "buyer_preview_simulation" },
    license: { status: "preview", present: false },
    profile: { rfc: "", razon_social: "", responsable: "" },
    installation_id: "",
    module_permissions: {
      entitlements: { visor: true, laboral: false, tramites: true, despacho: false },
      source: "buyer_preview_simulation",
    },
    _buyer_preview: { simulated: true, organization_id: null },
  };
}

const MODULE_TO_ENTITLEMENT = {
  visor: "visor",
  laboral: "laboral",
  tramites: "tramites",
  despacho: "despacho",
};

function modulesToEntitlements(modules = {}) {
  const entitlements = { visor: false, laboral: false, tramites: false, despacho: false };
  Object.entries(modules || {}).forEach(([key, active]) => {
    const ent = MODULE_TO_ENTITLEMENT[key] || key;
    if (ent in entitlements) entitlements[ent] = Boolean(active);
  });
  return entitlements;
}

/**
 * Construye systemInfo de solo lectura a partir de organización + licencia BNT (Centro SaaS).
 * No modifica backend ni permisos del diseñador.
 */
export function buildBuyerPreviewSystemInfoFromOrganization(org, license, baseSystemInfo = {}) {
  if (!org) return buildEmptyBuyerPreviewSimulationSystemInfo();

  const modules = license?.modules || {};
  const entitlements = modulesToEntitlements(modules);
  const hasActiveLicense = license?.status === "active" && license?.is_current !== false;
  const validFrom = license?.valid_from ? String(license.valid_from).slice(0, 10) : "";
  const validTo = license?.valid_to ? String(license.valid_to).slice(0, 10) : "";

  return {
    ...baseSystemInfo,
    entitlements,
    subscription: hasActiveLicense
      ? { mode: "licensed", ok: true, reason: null }
      : { mode: "trial", ok: false, reason: "trial_expired" },
    license: hasActiveLicense
      ? {
          status: "active",
          present: true,
          payload: {
            licensee_name: org.name || org.organization_name || "",
            licensee_rfc: org.rfc || org.organization_rfc || "",
            valid_from: validFrom,
            valid_to: validTo,
            plan: license?.plan || "Organización BNT",
          },
          authorized_users: license?.authorized_users,
          authorized_clients: license?.authorized_clients,
        }
      : { status: "missing", present: false },
    profile: {
      rfc: org.rfc || org.organization_rfc || "",
      razon_social: org.name || org.organization_name || "",
      responsable: org.contact_name || org.primary_contact || "",
    },
    installation_id: license?.installation_id || "",
    module_permissions: {
      entitlements,
      source: hasActiveLicense ? "buyer_preview_organization" : "buyer_preview_simulation",
    },
    _buyer_preview: {
      simulated: false,
      organization_id: org.id || org.organization_id || null,
      organization_name: org.name || org.organization_name || "",
    },
  };
}

/** En preview de diseñador no se muestran CTAs legacy de activación manual. */
export function shouldShowLegacyLicenseActivationInBuyerPreview() {
  return false;
}
